import styled from '@emotion/styled';
import { yupResolver } from '@hookform/resolvers/yup';
import { Form, FormInputSearch, pxToRem, useForm } from '@modernhealth/vital-components';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

import { navigationService } from 'src/config/rootService';

import { mediaQueries } from '../../../../shared/styles/variables';
import { useLocation } from 'react-router-dom';

type FormType = {
    searchField?: string;
};

export const AdminSearchContainer = styled.div({
    display: 'flex',
    width: pxToRem(400),

    [mediaQueries.xxl]: {
        width: pxToRem(350),
    },
    [mediaQueries.xl]: {
        width: pxToRem(300),
    },
});

export const AdminSearch: React.FC = () => {
    const { t } = useTranslation();
    const formSchema: Yup.ObjectSchema<FormType> = Yup.object().shape({
        searchField: Yup.string(),
    });

    const definition = useForm<FormType>({
        resolver: yupResolver(formSchema),
    });

    const formRef = useRef<HTMLFormElement>(null);

    const onSubmit = () => {
        const searchValue = definition.getValues('searchField');
        navigationService.navigate(`/admin/resources/search?phrase=${searchValue}`);
    };

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const phrase = searchParams.get('phrase') || '';

    return (
        <>
            <span id="global-search-label" hidden style={{ display: 'none' }}>
                Search
            </span>
            <Form definition={definition} onSubmit={onSubmit} formRef={formRef}>
                <FormInputSearch
                    formRef={formRef}
                    labelledBy="global-search-label"
                    name="searchField"
                    options={[]}
                    placeholder={t('admin:admin_search.placeholder')}
                    value={phrase}
                />
            </Form>
        </>
    );
};
